import { render, staticRenderFns } from "./tree-popover.vue?vue&type=template&id=3a98a51a&scoped=true&"
import script from "./tree-popover.vue?vue&type=script&lang=tsx&"
export * from "./tree-popover.vue?vue&type=script&lang=tsx&"
import style0 from "./tree-popover.vue?vue&type=style&index=0&id=3a98a51a&prod&lang=scss&scoped=true&"
import style1 from "./tree-popover.vue?vue&type=style&index=1&id=3a98a51a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a98a51a",
  null
  
)

export default component.exports